<div class="hunt-query-card">
  <div class="header" [class.no-margin]="!isOpen">
    <div class="logo">
      <img width="20px" [src]="getToolIcon(tool.product)" />
      <hyperkit-typography variant="emphasized" size="sm" color="primary">
        {{ truncate(tool.name) }}
      </hyperkit-typography>
    </div>
    <div class="page-counter" (click)="toggleOpen()" style="cursor: pointer">
      <hyperkit-icon
        [icon]="isOpen ? 'chevron-up' : 'chevron-down'"
        size="medium"
      ></hyperkit-icon>
    </div>
  </div>

  @if (isOpen) {
    <div class="endpoints">
      @for (q of queries; track trackByQuery($index, q)) {
        @if (q.id) {
          <!-- pivot‐enabled queries -->
          @if (hasPivots(q)) {
            <pivot-dropdown
              [items]="q.pivots!"
              [huntQueryId]="q.id"
              [status]="q.status"
              [toolId]="tool.id"
              [headerLabel]="title(q)"
              (selectPivot)="onSelect($event)"
              [headerCategory]="q.category"
            ></pivot-dropdown>
          } @else {
            <div
              class="endpoint-item"
              [class.active]="isActive(q)"
              (click)="onQueryClick(q)"
            >
              <hyperkit-icon
                icon="circle-filled"
                size="small"
                [color]="q.status | queryStatusColor"
                class="code-icon"
              ></hyperkit-icon>
              <hyperkit-typography
                variant="emphasized"
                size="sm"
                class="endpoint-name"
                [wrap]="false"
                color="primary"
              >
                {{ title(q) }}
              </hyperkit-typography>
              <hyperkit-badge
                variant="neutral"
                [text]="q.category"
              ></hyperkit-badge>
            </div>
          }
          <!-- single‐row queries -->
        }
      }
    </div>
  }
</div>
